var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnalysis105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5 16C9.22386 16 9 16.2239 9 16.5C9 16.7761 9.22386 17 9.5 17H69.5C69.7761 17 70 16.7761 70 16.5C70 16.2239 69.7761 16 69.5 16H9.5ZM9.5 40C9.22386 40 9 40.2239 9 40.5C9 40.7761 9.22386 41 9.5 41H37.5C37.7761 41 38 40.7761 38 40.5C38 40.2239 37.7761 40 37.5 40H9.5ZM9.5 64C9.22386 64 9 64.2239 9 64.5C9 64.7761 9.22386 65 9.5 65H37.5C37.7761 65 38 64.7761 38 64.5C38 64.2239 37.7761 64 37.5 64H9.5ZM9 88.5C9 88.2239 9.22386 88 9.5 88H69.5C69.7761 88 70 88.2239 70 88.5C70 88.7761 69.7761 89 69.5 89H9.5C9.22386 89 9 88.7761 9 88.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54 52.5C54 43.9396 60.9396 37 69.5 37C78.0604 37 85 43.9396 85 52.5C85 56.7625 83.2794 60.6232 80.4949 63.4253C80.4825 63.4355 80.4705 63.4464 80.4589 63.458C80.4474 63.4696 80.4365 63.4816 80.4263 63.4939C77.624 66.279 73.763 68 69.5 68C60.9396 68 54 61.0604 54 52.5ZM80.8089 64.515C77.8555 67.2959 73.8767 69 69.5 69C60.3873 69 53 61.6127 53 52.5C53 43.3873 60.3873 36 69.5 36C78.6127 36 86 43.3873 86 52.5C86 56.8762 84.2963 60.8546 81.516 63.8079L95.8541 78.146C96.0493 78.3412 96.0493 78.6578 95.8541 78.8531C95.6588 79.0483 95.3422 79.0483 95.1469 78.8531L80.8089 64.515Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgAnalysis105;